import React, { useState, useEffect } from 'react';

const Success = () => {
  const [submissionData, setSubmissionData] = useState(null);

  useEffect(() => {
    // Get submission data from session storage
    const savedSubmissionData = sessionStorage.getItem('submissionData');
    if (savedSubmissionData) {
      try {
        const parsedData = JSON.parse(savedSubmissionData);
        setSubmissionData(parsedData);
      } catch (err) {
        console.error('Error parsing submission data:', err);
      }
    }
  }, []);

  if (!submissionData) {
    return (
      <div className="main-content">
        <div className="text-center">
          <h1 className="text-type-2 text-header">Loading...</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-container" style={{ maxWidth: '700px' }}>
        <div className="success-message bg-success" style={{ padding: '2rem', borderRadius: '0.5rem', border: '1px solid var(--som-success)', borderLeft: '4px solid var(--som-success)', marginBottom: '40px' }}>
          <p className="text-type-4 text-success" style={{ margin: '0 0 10px 0', fontWeight: '600' }}>Submission Successful!</p>
          <p className="text-type-5 text-body" style={{ margin: '0' }}>
            <span className="sr-only">Success: </span>
            Your bed data has been successfully submitted and recorded. You may now close the window.
          </p>
        </div>

        <div className="thank-you" style={{ textAlign: 'center', marginTop: '30px', padding: '2rem', backgroundColor: '#f9f9f9', borderRadius: '0.5rem' }}>
          <p className="text-type-5 text-body" style={{ margin: '0' }}>
            For questions or support, please contact: <a href="mailto:MDHHS-JJReform@michigan.gov">MDHHS-JJReform@michigan.gov</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Success;